import axios from "../../plugins/axios";
import utils from "../../../utils/utils";

class File {
    //INTF-00549：使用本地文件名，请求获取存到服务端的文件名
    getFileNameForServer(name) {
        let body = { fileName: name };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/GetFileUpName`, body);
    }

    //INTF-00550：获取上传文件所需要的PolicyToken
    getPolicyTokenForUpload(module) {
        let body = { moduleName: module };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/GetFileUploadToken`, body);
    }

    //INTF-00551：文件上传成功后，通知应用服务端记录文件在OSS上的存储信息，获取文件存储信息记录在应用服务器上的uid信息
    recordForUploadSuccess(module, fileName, dir) {
        let body = { moduleName: module, fileName: fileName, fileDir: dir };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/FileUploadSuccess`, body);
    }

    //INTF-00552：获取不同的模块中的文件模板地址
    getFileTemplate(module) {
        let body = { moduleName: module };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/GetFileTemplate`, body);
    }

    //--------------------------采购订单相关-------------------------//
    //INTF-00553：将已上传oss的附件的信息与采购订单头建立关联关系
    uploadFileForPoHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "purchase", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.FilePurchaseHeaderProvider/FileUploadSuccess`, body);
    }

    //INTF-00554：删除采购订单头下的附件
    deleteFileForPoHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.FilePurchaseHeaderProvider/ModuleFileDelete`, body);
    }

    //INTF-00555：获取采购订单头下附件的url和文件名，触发服务端允许下载
    getFileInfoForPoHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "purchase", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myPurchaseOrderApp/service.FilePurchaseHeaderProvider/DownUploadFile`, body);
    }

    //-----------------------------对账单相关----------------------------//
    //INTF-00556：将已上传oss的附件的信息与对账单头建立关联关系
    uploadFileForBillHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "notice", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.FileNoticeHeaderProvider/FileUploadSuccess`, body);
    }

    //INTF-00557：删除对账单头下的附件
    deleteFileForBillHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.FileNoticeHeaderProvider/ModuleFileDelete`, body);
    }

    //INTF-00558：获取对账单头下附件的url和文件名，触发服务端允许下载
    getFileInfoForBillHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "notice", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySupplierApp/service.FileNoticeHeaderProvider/DownUploadFile`, body);
    }

    //-----------------------------供应商提供的票据相关-----------------------//
    //INTF-00559：将已上传oss的附件的信息与供应商票据建立关联关系
    uploadFileForSupplierInvoiceHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "billPurchase", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.FileBillHeaderProvider/PurchaseFileUploadSuccess`, body);
    }

    //INTF-00560：删除供应商票据下的附件
    deleteFileForSupplierInvoiceHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.FileBillHeaderProvider/PurchaseModuleFileDelete`, body);
    }

    //INTF-00561：获取供应商票据下附件的url和文件名，触发服务端允许下载
    getFileInfoForSupplierInvoiceHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "billPurchase", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myBillApp/service.FileBillHeaderProvider/PurchaseDownUploadFile`, body);
    }

    //-------------------------------销售订单相关------------------------------//
    //INTF-00562：将已上传oss的附件的信息与销售订单建立关联关系
    uploadFileForSoHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "sale", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.FileSaleHeaderProvider/FileUploadSuccess`, body);
    }

    //INTF-00563：删除销售订单下的附件
    deleteFileForSoHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.FileSaleHeaderProvider/ModuleFileDelete`, body);
    }

    //INTF-00564：获取销售订单下附件的url和文件名，触发服务端允许下载
    getFileInfoForSoHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "sale", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/mySaleOrderApp/service.FileSaleHeaderProvider/DownUploadFile`, body);
    }

    //--------------------------客户收货单相关----------------------------//
    //INTF-00566：将已上传oss的附件的信息与客户收货单建立关联关系
    uploadFileForCrHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "customerReceipt", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/CustomerReceiptFileUploadSuccess`, body);
    }

    //INTF-00567：删除客户收货单下的附件
    deleteFileForCrHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/CustomerReceiptModuleFileDelete`, body);
    }

    //INTF-00568：获取客户收货单下附件的url和文件名，触发服务端允许下载
    getFileInfoForCrHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "customerReceipt", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/CustomerReceiptDownUploadFile`, body);
    }

    //----------------------采购收货单相关---------------------//
    //INTF-00569：将已上传oss的附件的信息与采购收货单建立关联关系
    uploadFileForGrHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "goodsReceive", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReceiveFileUploadSuccess`, body);
    }

    //INTF-00570：删除采购收货单下的附件
    deleteFileForGrHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReceiveModuleFileDelete`, body);
    }

    //INTF-00571：获取采购收货单下附件的url和文件名，触发服务端允许下载
    getFileInfoForGrHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "goodsReceive", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReceiveDownUploadFile`, body);
    }

    //---------------------库存移动单相关--------------------------//
    //INTF-00572：将已上传oss的附件的信息与库存移动单建立关联关系
    uploadFileForStockMoveHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "stockMove", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/StockMoveFileUploadSuccess`, body);
    }

    //INTF-00573：删除库存移动单下的附件
    deleteFileForStockMoveHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/StockMoveModuleFileDelete`, body);
    }

    //INTF-00574：获取库存移动单下附件的url和文件名，触发服务端允许下载
    getFileInfoForStockMoveHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "stockMove", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/StockMoveDownUploadFile`, body);
    }

    //----------------------采购退货单相关--------------------//
    //INTF-00661：将已上传oss的附件的信息与采购退货单建立关联关系
    uploadFileForGoodsReturnHeader(fileName, dir, id, route) {
        let body = { types: "object,object", values: [{ moduleName: "goodsReturn", fileName: fileName, fileDir: dir, parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReturnFileUploadSuccess`, body);
    }

    //INTF-00662：删除采购退货单下的附件
    deleteFileForGoodsReturnHeader(id, route) {
        let body = { types: "object,object", values: [{ parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReturnModuleFileDelete`, body);
    }

    //INTF-00663：获取采购退货单下附件的url和文件名，触发服务端允许下载
    getFileInfoForGoodsReturnHeader(id, route) {
        let body = { types: "object,object", values: [{ moduleName: "goodsReturn", parameter: String(id) }, utils.getUidAndToken(route)] };
        return axios.post(`/myStockMoveApp/service.FileStockHeaderProvider/GoodsReturnDownUploadFile`, body);
    }


    //-----------更新的共用的上传、下载附件---------------------//
    //INTF-00766：上传文件成功通知服务器
    uploadFileByModuleNameById(moduleName, fileName, fileDir, id) {
        let body = { moduleName: moduleName, fileName: fileName, fileDir: fileDir, parameter: String(id) };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/UploadAttachmentSuccess`, body);

    }

    //INTF-00767：删除已经上传的附件
    deleteUploadedFileByModuleNameById(moduleName, id) {
        let body = { moduleName: moduleName, parameter: String(id) };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/DeleteAttachment`, body);
    }

    //INTF-00768：获取文件的url和文件名，触发服务端允许下载
    getFileInfoByModuleNameById(moduleName, id) {
        let body = { moduleName: moduleName, parameter: String(id) };
        return axios.post(`/myBasicDataApp/service.basic_file.BasicFileProvider/DownloadAttachment`, body);
    }


}
export default File;